//This file is automatically rebuilt by the Cesium build process.
export default "vec3 czm_inverseGamma(vec3 color) {\n\
return pow(color, vec3(1.0 / czm_gamma));\n\
}\n\
";
